export default {
    bindings: {
        guests: '=',
        maybeRequestAvailability: '&'
    },
    controller: 'logInOutController',
    template: require('../views/logInOut.menu.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/components/logInOut.menu.component.js